export default{divider:"w_Aa"};
